import React from 'react';
import { Icon, Text } from '@cubeyou-team/hx-react-components';

import { FreeTrialWrapper } from '../../components/free-trial-wrapper';
import translations from '../../../../lang';

const { FREE_TRIAL } = translations['en-US'];

export const ExpiredInvitation = () => {
  return (
    <FreeTrialWrapper>
      <div className="flex flex-col items-center justify-center gap-4 py-6">
        <div className="w-full flex items-center justify-center">
          <div className="w-16 h-16 bg-hx-error rounded-full flex items-center justify-center">
            <Icon icon="remove" size="medium" variant="light_darker" />
          </div>
        </div>
        <Text align="center" tag="h4" size="headline">
          {FREE_TRIAL.EXPIRED_INVITATION.TITLE}
        </Text>
        <Text align="start" tag="h2" size="xbody">
          {FREE_TRIAL.EXPIRED_INVITATION.MESSAGE}
        </Text>
      </div>
    </FreeTrialWrapper>
  );
};
